import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const directiveComplexitySchema = z.object({
  complexity: optionSchema,
});

export const establishmentChoiceEntrySchema = z.object({
  establishment_choice_entry_type: z.string(),
  establishment_choice_entry_attributes: z.object({
    establishment_id: z.string(),
  }),
});

export const checkinEntrySchema = z.object({
  checkin_entry_type: z.string(),
  checkin_entry_attributes: z.object({
    responsible: optionSchema,
  }),
});

export type DirectiveComplexityValidationSchema = z.infer<typeof directiveComplexitySchema>;

export type EstablishmentChoiceEntryValidationSchema = z.infer<typeof establishmentChoiceEntrySchema>;

export type CheckinEntryValidationSchema = z.infer<typeof checkinEntrySchema>;
